module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "bounce-up"
    }
  }, [(_vm.hasFooterBar) ? _c('footer', {
    staticClass: "footer-bar"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('layout.footer.info')))]), _vm._v(" "), _c('action', {
    attrs: {
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('reset')
      }
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.$t('layout.footer.cancel')))])]), _vm._v(" "), _c('action', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('submit')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('layout.footer.save')) + "\n        ")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23aafdae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/FooterBar.vue
// module id = 529
// module chunks = 225